import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    trigger: '[data-css-hover]',
    parent: '[data-css-hover-parent]',
  },
  classNames: {
    hover: 'is-hover',
    hoverBefore: 'is-before-hover',
    hoverOut: 'is-hover-out',
  },
  dataNames: {
    hoverStep: 'hoverStep',
    hoverNumber: 'hoverNum',
    hoverInDuration: 'hoverInDuration',
    hoverOutDuration: 'hoverOutDuration',
    hoverParent: 'hoverParent',
  },
  duration: {
    hoverBefore: 0.0,
  },
}

export default class CssHover {
  $contentRoot = document
  $triggers = null
  triggerInfoList = []

  event = {
    mouseEnter: this._onMouseEnter.bind(this),
    mouseLeave: this._onMouseLeave.bind(this),
  }

  beforeHoverInHandler = []
  hoverInHandler = []
  beforeHoverOutHandler = []
  hoverOutHandler = []
  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.$triggers.forEach(($trigger, i) => {
      this._setTargetInfoList($trigger, i)
      this._addEventListeners($trigger)
    })
  }

  destroy() {
    this.$triggers.forEach(($trigger, i) => {
      this._removeEventListeners($trigger)
    })
  }

  _set$() {
    this.$triggers = this.$contentRoot.querySelectorAll(this.$names.trigger)
  }

  _setTargetInfoList($trigger, i) {
    const data = $trigger.dataset
    const step = Number(data[this.dataNames.hoverStep]) || 1
    const inDuration = parseFloat(data[this.dataNames.hoverInDuration]) || 0
    const outDuration = parseFloat(data[this.dataNames.hoverOutDuration]) || 0

    if (data[this.dataNames.hoverStep]) {
      delete data[this.dataNames.hoverStep]
    }

    if (data[this.dataNames.hoverInDuration]) {
      delete data[this.dataNames.hoverInDuration]
    }

    if (data[this.dataNames.hoverOutDuration]) {
      delete data[this.dataNames.hoverOutDuration]
    }

    let hoverParent = data[this.dataNames.hoverParent]

    if (hoverParent !== undefined && hoverParent !== null) {
      if (hoverParent === '') {
        hoverParent = $trigger.closest(this.$names.parent) || $trigger.parentNode
      } else {
        hoverParent = $trigger.closest(hoverParent) || $trigger.closest(this.$names.parent) || $trigger.parentNode
      }
    }

    $trigger.dataset[this.dataNames.hoverNumber] = i

    this.triggerInfoList[i] = {
      step: step,
      inDuration: inDuration,
      outDuration: outDuration,
      isHovering: false,
      isAnimating: false,
      hoverParent: hoverParent,
    }
  }

  _addEventListeners($trigger) {
    $trigger.addEventListener('mouseenter', this.event.mouseEnter, false)
    $trigger.addEventListener('mouseleave', this.event.mouseLeave, false)
  }

  _removeEventListeners($trigger) {
    $trigger.removeEventListener('mouseenter', this.event.mouseEnter)
    $trigger.removeEventListener('mouseleave', this.event.mouseLeave)
  }

  _onMouseEnter(e) {
    let $trigger = e.currentTarget
    const num = Number($trigger.dataset[this.dataNames.hoverNumber])
    const infoListItem = this.triggerInfoList[num]
    infoListItem.isHovering = true

    if (infoListItem.hoverParent) {
      $trigger = infoListItem.hoverParent
    }

    if (!infoListItem.isAnimating) {
      this._startMouseEnter($trigger, num, infoListItem)
    }
  }

  _onMouseLeave(e) {
    let $trigger = e.currentTarget
    const num = Number($trigger.dataset[this.dataNames.hoverNumber])
    const infoListItem = this.triggerInfoList[num]

    infoListItem.isHovering = false

    if (infoListItem.hoverParent) {
      $trigger = infoListItem.hoverParent
    }

    if (!infoListItem.isAnimating) {
      this._startMouseLeave($trigger, num, infoListItem)
    }
  }

  _startMouseEnter($this, num, infoListItem) {
    const duration = infoListItem.inDuration
    infoListItem.isAnimating = true

    if (infoListItem.step >= 2) {
      const wait = this.duration.hoverBefore

      $this.classList.add(this.classNames.hoverBefore)
      this.beforeHoverInHandler.forEach((el) => {
        el.task($this)
      })

      gsap.delayedCall(wait, () => {
        requestAnimationFrame(() => {
          $this.classList.add(this.classNames.hover)
          $this.classList.remove(this.classNames.hoverBefore)
          this.hoverInHandler.forEach((el) => {
            el.task($this)
          })
        })
      })

      gsap.delayedCall(wait + duration, () => {
        requestAnimationFrame(() => {
          this._completeMouseEnter($this, num, infoListItem)
        })
      })
    } else {
      $this.classList.add(this.classNames.hover)
      this.hoverInHandler.forEach((el) => {
        el.task($this)
      })

      gsap.delayedCall(duration, () => {
        this._completeMouseEnter($this, num, infoListItem)
      })
    }
  }

  _startMouseLeave($this, num, infoListItem) {
    let duration = infoListItem.outDuration
    infoListItem.isAnimating = true

    requestAnimationFrame(() => {
      $this.classList.add(this.classNames.hoverOut)
      $this.classList.remove(this.classNames.hover)
      this.beforeHoverOutHandler.forEach((el) => {
        el.task($this)
      })

      gsap.delayedCall(duration, () => {
        this._completeMouseLeave($this, num, infoListItem)
      })
    })
  }

  _completeMouseEnter($this, num, infoListItem) {
    infoListItem.isAnimating = false

    if (!infoListItem.isHovering) {
      this._startMouseLeave($this, num, infoListItem)
    }
  }

  _completeMouseLeave($this, num, infoListItem) {
    infoListItem.isAnimating = false

    $this.classList.remove(this.classNames.hoverOut)
    this.hoverOutHandler.forEach((el) => {
      el.task($this)
    })

    requestAnimationFrame(() => {
      if (infoListItem.isHovering) {
        this._startMouseEnter($this, num, infoListItem)
      }
    })
  }
}